import React, { useEffect } from 'react';
import { LFC } from '../../Legacy';
import { Button, Prompt } from '../../ui';
import { useResolve } from '../Container';
import { useFeatureCheck } from '../common/FeatureElements';
import { ButtonStrip, Copy, LinkButton } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { PopupManager } from '../popups/PopupManager';
import { UpgradeButton } from '../upgrade/UpgradeButton';
import { AccountModel } from './AccountModel';

const Expired = ({ dismiss }: Pick<PopupProps, 'dismiss'>) => {
    const account = useResolve(AccountModel);
    if (!account.plan.name.includes('expired')) return null;

    return <>
        <Popup.Title>Your trial has expired!</Popup.Title>
        <Popup.Content>
            <Copy>
                <p>
                    Sorry, your trial has now expired.  To continue using Metro Retro, please upgrade your team.
                </p>
            </Copy>
        </Popup.Content>
        <ButtonStrip align="center">
            <UpgradeButton label="View Plans" variant="positive" />
            <Button onAction={dismiss}>Close</Button>
        </ButtonStrip>
    </>;
};

const Closed = ({ dismiss }: Pick<PopupProps, 'dismiss'>) => {
    const account = useResolve(AccountModel);
    if (!account.plan.name.includes('closed')) return null;

    return <>
        <Popup.Title>Your plan has been cancelled!</Popup.Title>
        <Popup.Content>
            <Copy>
                <p>
                    To continue using Metro Retro, please reactivate your account.
                </p>
            </Copy>
        </Popup.Content>
        <ButtonStrip align="center">
            <UpgradeButton label="Reactivate" variant="positive" />
            <Button onAction={dismiss}>Close</Button>
        </ButtonStrip>
    </>;
};

const Failed = ({ dismiss }: Pick<PopupProps, 'dismiss'>) => {
    const account = useResolve(AccountModel);
    if (!account.plan.name.includes('failed')) return null;

    return <>
        <Popup.Title>Your account is past due!</Popup.Title>
        <Popup.Content>
            <Copy>
                <p>
                    Your most recent payment failed.  Please update your payment information to continue using Metro Retro.
                </p>
            </Copy>
        </Popup.Content>
        <ButtonStrip align="center">
            <LinkButton variant="primary" target="_blank" href={`/billing/payment?accountId=${account.id}`}>
                Update Now
            </LinkButton>
            <Button onAction={dismiss}>Close</Button>
        </ButtonStrip>
    </>;
};

export const accountReadonlyPopup = () => ({ ui: AccountReadonlyPopup, args: {} });

export const AccountReadonlyPopup: LFC<PopupProps> = (props) => {
    return <Prompt ignoreEnter onAction={props.dismiss}>
        <Popup w={36}>
            <Popup.Close onAction={props.dismiss} />
            <Expired {...props} />
            <Closed {...props} />
            <Failed {...props} />
        </Popup>
    </Prompt>;
};

export const InvokeAccountReadonlyPopupIfApplicable = () => {

    const popups = useResolve(PopupManager);
    const readonly = useFeatureCheck('readonly');

    useEffect(() => {
        if (readonly) {
            popups.invoke(accountReadonlyPopup());
        }
    }, [readonly]);

    return null;
};
